const [w] = [window]

export default function ABOUT() {
  
  $(() => {

    //ハッシュナビカレント
    const hashCurrent = () => {
      const $nav = $('.p-about-nav'),
            hash = location.hash,
            currentClass = 'current'
      if( hash == '' ) return false
      $nav.each( function() {
        $(`a.${currentClass}`, this ).removeClass(currentClass)
        const $current = $( `a[href$="${hash}"]`, this )
        if( $current.length ) $current.addClass( currentClass );
      });
    }
    w.load['about'].done( hashCurrent );
    $(w).on('hashchange', hashCurrent);

  })
}